import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../components/sections/Home/Home.css';
import SliderHome from '../components/sections/Home/SliderHome';
import UnoHome from '../components/sections/Home/UnoHome';
import CatalogoPisosHome from '../components/sections/Home/CatalogoPisosHome';
import BeneficiosHome from '../components/sections/Home/BeneficiosHome';
import CatalogoMurosHome from '../components/sections/Home/CatalogoMurosHome';
import CalculadoraHome from '../components/sections/Home/CalculadoraHome';
import FormularioContactoHome from '../components/sections/Home/FormularioContactoHome';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const Home = () => {
  return (
    <div className="dt-home">
      <Helmet>
        <title>Inicio | Decototal</title>
        <meta name="description" content="Decototal comercializadora, consulta nuestro catálogo, tenemos entrega inmediata." />
        <meta name="keywords" content="Decototal comercializadora, Cotización Deco Total, Decototal, Pisos" />
        <link rel="canonical" href="https://decototal.com.mx/" />
        <meta property="og:title" content="Sitio Oficial Decototal" />
        <meta property="og:description" content="Decototal Comercializadora, Escríbenos y obtén información personalizada." />
        <meta property="og:image" content="https://decototal.com.mx/assets/img/home/slide-index-hot-sale.jpg" />
        <meta property="og:url" content="https://decototal.com.mx/" />
      </Helmet>
      <Header />
      <SliderHome />
      <UnoHome />
      <CatalogoPisosHome />
      <BeneficiosHome />
      <CatalogoMurosHome />
      <CalculadoraHome />
      <FormularioContactoHome />
      <Footer />
    </div>
  );
};

export default Home;